import { css } from '@emotion/react';
import { AnimatePresence, motion } from 'motion/react';
import { useCalendarView } from '../providers';
import { EVENT_CARD_DEFAULT_MEASUREMENTS, zIndex } from '../utils';

export const BackgroundOverlay = () => {
  const { backgroundView } = useCalendarView(['backgroundView']);

  return (
    <AnimatePresence>
      {backgroundView && (
        <motion.article
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          css={backgroundStyle}
        />
      )}
    </AnimatePresence>
  );
};

const backgroundStyle = css({
  backgroundColor: 'rgba(0, 33, 82, 0.1)',
  zIndex: zIndex.backgroundOverlay,
  position: 'absolute',
  left: 0,
  marginLeft: -EVENT_CARD_DEFAULT_MEASUREMENTS.condensedHeight,
  top: 0,
  height: `calc(100% + ${EVENT_CARD_DEFAULT_MEASUREMENTS.condensedHeight}px)`,
  width: `calc(100% + ${EVENT_CARD_DEFAULT_MEASUREMENTS.condensedHeight}px)`,
  marginTop: -EVENT_CARD_DEFAULT_MEASUREMENTS.condensedHeight,
});
